import gsap from 'gsap'

import {
  getScrollTriggerOptions,
  linesRevealAnimation,
  type SharedAnimation
} from '@/components/sections/animations/shared'

import { Animation } from '@/types'

export const editorialHorizontalTextRevealAnimation = ({
  node,
  context,
  reverse,
  delay = 0
}: Animation) => {
  const selector = context?.selector || gsap.utils.selector(node)

  const title = selector('[data-motion-title]')[0]
  const text1 = selector('[data-motion-text-1]')[0]
  const text2 = selector('[data-motion-text-2]')[0]

  const timeline = gsap.timeline({
    ...getScrollTriggerOptions(node, reverse),
    delay
  })

  let titleAnimation: SharedAnimation
  if (title) {
    titleAnimation = linesRevealAnimation(title, reverse)
    timeline.add(titleAnimation.timeline, 0)
  }

  let text1Animation: SharedAnimation
  if (text1) {
    text1Animation = linesRevealAnimation(text1, reverse)
    timeline.add(text1Animation.timeline, 0.1)
  }

  let text2Animation: SharedAnimation
  if (text2) {
    text2Animation = linesRevealAnimation(text2, reverse)
    timeline.add(text2Animation.timeline, 0.2)
  }

  return () => {
    timeline.scrollTrigger?.kill()
    timeline.kill()

    titleAnimation?.revert()
    text1Animation?.revert()
    text2Animation?.revert()
  }
}
